import React, { useEffect, useCallback, useState} from 'react';
import {loadProjectTracks} from 'operations/actions.js';
import TrackSteps from './TrackSteps.js';
import PatternNumbers from './PatternNumbers.js';
import SubSequenceButtons from './SubSequenceButtons.js';
import Thumbnail from './Thumbnail.js';
import {loadProject} from './loadProject.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
const colors = new Colors();

const ExpandedProject = ({sequencerEngine, project}) => { 
    let [patternNumber, setPatternNumber] = useState(0);
    let [subSequence, setSubSequence] = useState(0);
    let [loadedProject, setLoadedProject] = useState(undefined);
    let [selectedTracks, setSelectedTracks] = useState([]);

    const loadEntireProject = useCallback(() => {
        sequencerEngine.loadSequence(project.newSequence);
    }, [project]);

    useEffect(() => {
        loadProject(project.newSequence).then(setLoadedProject);
    }, [setLoadedProject]);

    const onClickTrack = useCallback((t) => {
        if (selectedTracks.includes(t)) {
            setSelectedTracks(selectedTracks.filter(x => x !== t));
        } else {
            setSelectedTracks([... selectedTracks, t]);
        }
    }, [selectedTracks, setSelectedTracks]);

    if (!loadedProject || loadedProject.length === 0) {
        return [];
    }
    return (
        <div className="expanded-project">
          <div className="expanded-toolbar">
            <PatternNumbers
              patterns={loadedProject[0][0].patterns.length}
              patternNumber={patternNumber}
              setPatternNumber={setPatternNumber}/>
            <SubSequenceButtons
              subSequences={loadedProject.length}
              subSequence={subSequence}
              setSubSequence={setSubSequence}/>
            <div onClick={loadEntireProject} className="load-project-btn">
              Load Entire Project
            </div>
          </div>
          <Sub
            sequencerEngine={sequencerEngine}
            onClickTrack={onClickTrack}
            selectedTracks={selectedTracks}
            patternNumber={patternNumber}
            sub={loadedProject[subSequence]}/>
        </div>);
}

const Sub = ({sub, patternNumber, onClickTrack, selectedTracks, sequencerEngine}) => {
    const load = useCallback(() => {
        sequencerEngine.operationManager.dispatch(
            loadProjectTracks(selectedTracks.length > 0 ? selectedTracks : sub, patternNumber));
    }, [selectedTracks, patternNumber, sub]);

    return (
        <div className="sub">
          <div onClick={load} className="load-btn">
            {selectedTracks.length === 0 ? "Load Pattern" : "Load " + selectedTracks.length + " tracks"}
          </div>
          {sub.map(
              track =>
                  <Track
                    onClick={() => onClickTrack(track)}
                    isSelected={selectedTracks.includes(track)}
                    patternNumber={patternNumber} track={track}/>)}
        </div>
    );
};

const Track = ({track, patternNumber, onClick, isSelected}) => {
    let id = track.sample ? track.sample.getId() : track.name;
    let color = id ?
        colors.getColorForHash(id) : "red";
    return (
        <div className="mini-track">
          <Thumbnail
            isSelected={isSelected}
            onClick={onClick}
            color={color} track={track}/>
          <div className="track-name">
            {truncate(track.name)}
          </div>
          <TrackSteps color={color} track={track} patternNumber={patternNumber}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const truncate = (name, len=12) => {
    if (name && name.length > len) {
        return name.slice(0, len) + '...';
    }
    return name;
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpandedProject);
